module.exports = __webpack_public_path__ + "static/media/manage_users.4a73f5d2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/new_menu_icons/manage_users.svg
// module id = 2710
// module chunks = 0